// @ts-nocheck
import * as __fd_glob_7 from "../content/docs/manual/index.mdx?collection=docs"
import * as __fd_glob_6 from "../content/docs/changelogs/index.mdx?collection=docs"
import * as __fd_glob_5 from "../content/docs/changelogs/0.3.1-beta.mdx?collection=docs"
import * as __fd_glob_4 from "../content/docs/changelogs/0.3.0-beta.mdx?collection=docs"
import * as __fd_glob_3 from "../content/docs/index.mdx?collection=docs"
import { default as __fd_glob_2 } from "../content/docs/manual/meta.json?collection=docs"
import { default as __fd_glob_1 } from "../content/docs/changelogs/meta.json?collection=docs"
import { default as __fd_glob_0 } from "../content/docs/meta.json?collection=docs"
import { server } from 'fumadocs-mdx/runtime/server';
import type * as Config from '../source.config';

const create = server<typeof Config, import("fumadocs-mdx/runtime/types").InternalTypeConfig & {
  DocData: {
  }
}>({"doc":{"passthroughs":["extractedReferences"]}});

export const docs = await create.docs("docs", "content/docs", {"meta.json": __fd_glob_0, "changelogs/meta.json": __fd_glob_1, "manual/meta.json": __fd_glob_2, }, {"index.mdx": __fd_glob_3, "changelogs/0.3.0-beta.mdx": __fd_glob_4, "changelogs/0.3.1-beta.mdx": __fd_glob_5, "changelogs/index.mdx": __fd_glob_6, "manual/index.mdx": __fd_glob_7, });